import { SecondaryButton } from "@egalite/ui/Buttons/GeneralButtons";
import Link from "next/link";
import { FC } from "react";

export const AnchorButton: FC = () => (
	<div className="text-center mb-60">
		<a href="#cadastro">
			<SecondaryButton>Quero participar</SecondaryButton>
		</a>
	</div>
);